import {BaseEvent} from "./BaseEvent";

export class LogoutEvent extends BaseEvent {
  public static NAME = 'logout';

  constructor() {
    super(LogoutEvent.NAME);
  }
}
